import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useInvalidateServerCartSummary } from "@faire/retailer-visitor-shared/features/Cart/ServerCart/useInvalidateServerCartSummary";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getCartToken } from "@faire/retailer-visitor-shared/serialized-data/getCartToken";
import { QueryParameters } from "@faire/web-api--source/api/v2/carts/cartToken/summary/get";
import { useQuery as useCartSummaryQuery, useInvalidateQuery as useInvalidateCartSummaryQuery, usePrefetchQuery as usePrefetchCartSummaryQuery } from "@faire/web-api--source/api/v2/carts/cartToken/summary/get-hooks";
import { IBrandCart } from "@faire/web-api--source/faire/carts/IBrandCart";
import { ICartSummaryResponseV2 } from "@faire/web-api--source/faire/carts/ICartSummaryResponseV2";
import { useCallback, useMemo } from "react";
export var useEntireCartSummary = function(arg) {
    var _useActiveCartSummary = useActiveCartSummary(arg), activeCartSummaryData = _useActiveCartSummary.data, isActiveCartSummaryPending = _useActiveCartSummary.isPending, isActiveCartSummaryLoading = _useActiveCartSummary.isLoading, isActiveCartSummaryFetching = _useActiveCartSummary.isFetching;
    var _useSavedCartSummary = useSavedCartSummary(arg), savedCartSummaryData = _useSavedCartSummary.data, isSavedCartSummaryPending = _useSavedCartSummary.isPending, isSavedLoading = _useSavedCartSummary.isLoading, isSavedFetching = _useSavedCartSummary.isFetching;
    var entireSummaryData = useMemo(function() {
        return ICartSummaryResponseV2.build(_object_spread_props(_object_spread({}, activeCartSummaryData), {
            brand_cart_summaries: _object_spread({}, activeCartSummaryData === null || activeCartSummaryData === void 0 ? void 0 : activeCartSummaryData.brand_cart_summaries, savedCartSummaryData === null || savedCartSummaryData === void 0 ? void 0 : savedCartSummaryData.brand_cart_summaries)
        }));
    }, [
        activeCartSummaryData,
        savedCartSummaryData === null || savedCartSummaryData === void 0 ? void 0 : savedCartSummaryData.brand_cart_summaries
    ]);
    return {
        data: entireSummaryData,
        isPending: isActiveCartSummaryPending || isSavedCartSummaryPending,
        isLoading: isActiveCartSummaryLoading || isSavedLoading,
        isFetching: isActiveCartSummaryFetching || isSavedFetching
    };
};
export var useSavedCartSummary = function(arg) {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _arg_brandTokens;
    return useCartSummaryQuery(getCartToken(), QueryParameters.build({
        brand_tokens: (_arg_brandTokens = arg === null || arg === void 0 ? void 0 : arg.brandTokens) !== null && _arg_brandTokens !== void 0 ? _arg_brandTokens : [],
        brand_cart_state: IBrandCart.State.SAVED_FOR_LATER
    }), {
        enabled: isLoggedInRetailer,
        refetchOnMount: false
    });
};
export var useActiveCartSummary = function(arg) {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _arg_brandTokens;
    return useCartSummaryQuery(getCartToken(), QueryParameters.build({
        brand_tokens: (_arg_brandTokens = arg === null || arg === void 0 ? void 0 : arg.brandTokens) !== null && _arg_brandTokens !== void 0 ? _arg_brandTokens : [],
        brand_cart_state: IBrandCart.State.ACTIVE
    }), {
        enabled: isLoggedInRetailer,
        refetchOnMount: false
    });
};
export var useInvalidateCartSummary = function(arg) {
    var invalidateCartSummaryQuery = useInvalidateCartSummaryQuery();
    var _useInvalidateServerCartSummary = useInvalidateServerCartSummary(), invalidateActiveServerCartSummary = _useInvalidateServerCartSummary.invalidateActiveServerCartSummary, invalidateSavedServerCartSummary = _useInvalidateServerCartSummary.invalidateSavedServerCartSummary;
    var invalidateCartSummaryData = useCallback(function(brandCartState) {
        var _arg_brandTokens;
        return invalidateCartSummaryQuery(getCartToken(), QueryParameters.build({
            brand_tokens: (_arg_brandTokens = arg === null || arg === void 0 ? void 0 : arg.brandTokens) !== null && _arg_brandTokens !== void 0 ? _arg_brandTokens : [],
            brand_cart_state: brandCartState
        }), undefined, {
            refetchType: "all"
        });
    }, [
        arg === null || arg === void 0 ? void 0 : arg.brandTokens,
        invalidateCartSummaryQuery
    ]);
    var invalidateActiveCartSummary = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _arg_brandTokens, promises;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = [
                        invalidateActiveServerCartSummary((_arg_brandTokens = arg === null || arg === void 0 ? void 0 : arg.brandTokens) !== null && _arg_brandTokens !== void 0 ? _arg_brandTokens : []),
                        invalidateCartSummaryData(IBrandCart.State.ACTIVE)
                    ];
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), [
        arg === null || arg === void 0 ? void 0 : arg.brandTokens,
        invalidateActiveServerCartSummary,
        invalidateCartSummaryData
    ]);
    var invalidateSavedCartSummary = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _arg_brandTokens, promises;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = [
                        invalidateSavedServerCartSummary((_arg_brandTokens = arg === null || arg === void 0 ? void 0 : arg.brandTokens) !== null && _arg_brandTokens !== void 0 ? _arg_brandTokens : []),
                        invalidateCartSummaryData(IBrandCart.State.SAVED_FOR_LATER)
                    ];
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), [
        arg === null || arg === void 0 ? void 0 : arg.brandTokens,
        invalidateCartSummaryData,
        invalidateSavedServerCartSummary
    ]);
    var invalidateEntireCartSummary = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            invalidateActiveCartSummary(),
                            invalidateSavedCartSummary()
                        ])
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), [
        invalidateActiveCartSummary,
        invalidateSavedCartSummary
    ]);
    return {
        invalidateEntireCartSummary: invalidateEntireCartSummary,
        invalidateActiveCartSummary: invalidateActiveCartSummary,
        invalidateSavedCartSummary: invalidateSavedCartSummary
    };
};
export var usePrefetchCartSummary = function(arg) {
    var prefetchCartSummary = usePrefetchCartSummaryQuery();
    var prefetchActiveCartSummary = useCallback(function() {
        var _arg_brandTokens;
        return prefetchCartSummary(getCartToken(), QueryParameters.build({
            brand_tokens: (_arg_brandTokens = arg === null || arg === void 0 ? void 0 : arg.brandTokens) !== null && _arg_brandTokens !== void 0 ? _arg_brandTokens : [],
            brand_cart_state: IBrandCart.State.ACTIVE
        }));
    }, [
        arg === null || arg === void 0 ? void 0 : arg.brandTokens,
        prefetchCartSummary
    ]);
    return {
        prefetchActiveCartSummary: prefetchActiveCartSummary
    };
};
